const { fetchAuthorizedJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');

function fetchDiamondsToClaim(apiUrl, token) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: 'v1/diamonds/claimable',
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching diamonds from offers ready to claim',
  });
}

function claimDiamondsFromOfferwalls(apiUrl, token, diamondsIds) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: 'v1/diamonds/claim',
    body: { ids: diamondsIds },
    expectedStatus: 200,
    description: 'Claiming diamonds from offerwalls',
  });
}

module.exports = {
  fetchDiamondsToClaim,
  claimDiamondsFromOfferwalls,
};
